/** Max upload size for gallery / admin images (30MB — supports high-resolution photos). */
export const MAX_IMAGE_UPLOAD_BYTES = 30 * 1024 * 1024;

export const ALLOWED_IMAGE_EXTENSIONS = ['jpg', 'jpeg', 'png'];

export const ALLOWED_IMAGE_MIME_TYPES = [
  'image/jpeg',
  'image/png',
  'image/pjpeg',
];

export function isAllowedImageFile(file) {
  if (!file) return false;
  const ext = String(file.name || '').split('.').pop()?.toLowerCase() || '';
  if (ALLOWED_IMAGE_EXTENSIONS.includes(ext)) return true;
  return ALLOWED_IMAGE_MIME_TYPES.includes(file.type);
}

export function maxImageUploadLabel() {
  const mb = Math.round(MAX_IMAGE_UPLOAD_BYTES / (1024 * 1024));
  return `JPG, JPEG, PNG up to ${mb}MB`;
}
